import * as types from '../../actions/ActionTypes.js';

const initialState = {
    isFetching: false,
    entities: []
};

const validateDeviceEpochSummary = (state = initialState, action) => {
    switch (action.type) {
        case types.REQUEST_VALIDATE_DEVICE_EPOCH_SUMMARY:
            return {
                ...initialState,
                isFetching: true
            };
        case types.RECEIVE_VALIDATE_DEVICE_EPOCH_SUMMARY:
            return {
                ...state,
                isFetching: false,
                entities: action.validateDeviceEpochSummary,
                lastUpdated: action.receivedAt
            };
        default:
            return state;
    }
};

export const getValidateDeviceEpochSummary = (state) => state.validateDeviceEpochSummary.entities;

export const getValidateDeviceEpochSummaryValue = (state, typeOfValue) =>
    state.validateDeviceEpochSummary.entities.reduce((entities, entity) => {
        const getValueByType = (entity, typeOfValue) => {
            switch (typeOfValue) {
                case 'steps':
                    return entity.minuteLevelSteps;
                case 'floors':
                    return entity.floorsAscendedInMeters;
                case 'calories':
                    return entity.activeKiloCalories;
                case 'distance':
                    return entity.distanceInMeters;
                case 'intensityMin':
                    var modIntensityMin = entity.moderateIntensityMinutes || 0;
                    var vigIntensityMin = entity.vigorousIntensityMinutes || 0;
                    if (modIntensityMin || vigIntensityMin) {
                        return modIntensityMin + 2 * vigIntensityMin;
                    } else {
                        return null;
                    }
                default:
                    return null;
            }
        };
        entities[entity.epochTimestamp] = getValueByType(entity, typeOfValue);
        return entities;
    }, {});

export default validateDeviceEpochSummary;
